<script>

export default {
  name: "MyAssetActionsMixin",
  data() {
    return {
      batch_progress: null,
      batch_progress_processed: 0,
      batch_progress_total: 0,
      batch_progress_label: '',
      batch_progress_refreshing: false,
    };
  },
  methods: {
    /** Prefer live grid selection; parent asset_ids_selected can lag behind checkbox UI. */
    resolvedSelectedAssetIds() {
      const fromGrid =
        this.$refs &&
        this.$refs.assetGrid &&
        Array.isArray(this.$refs.assetGrid.item_ids_selected)
          ? this.$refs.assetGrid.item_ids_selected
          : [];
      if (fromGrid.length > 0) {
        return fromGrid;
      }
      return Array.isArray(this.asset_ids_selected) ? this.asset_ids_selected : [];
    },
    async runBatchOperation(asset_ids, batchFn, progressLabelKey) {
      const ids = Array.isArray(asset_ids) ? asset_ids : this.resolvedSelectedAssetIds();
      this.loading = true;
      this.batch_progress = 0;
      this.batch_progress_processed = 0;
      this.batch_progress_total = ids.length;
      this.batch_progress_label = progressLabelKey;
      this.batch_progress_refreshing = false;
      try {
        await batchFn(ids, ({ percent, processed, total }) => {
          this.batch_progress = percent;
          this.batch_progress_processed = processed;
          this.batch_progress_total = total;
        });
        this.batch_progress = 100;
        this.batch_progress_refreshing = true;
        this.batch_progress_label = 'myassets.refreshing_assets';
        await this.load();
      } finally {
        this.loading = false;
        this.batch_progress = null;
        this.batch_progress_processed = 0;
        this.batch_progress_total = 0;
        this.batch_progress_label = '';
        this.batch_progress_refreshing = false;
      }
    },
    async validate_all() {
      this.loading = true;
      try {
        await this.$api.asset.mark_validated(this.resolvedSelectedAssetIds());
        await this.load();
      } finally {
        this.loading = false;
      }
    },
    async validate_filter() {
      this.loading = true;
      try {
        await this.$api.asset.mark_filter_validated(this.filters);
        await this.load();
      } finally {
        this.loading = false;
      }
    },
    async add_to_validation_set() {
      await this.runBatchOperation(
        this.resolvedSelectedAssetIds(),
        (ids, onProgress) => this.$api.asset.addToValidationSetInBatches(ids, onProgress),
        'myassets.adding_to_validation_set',
      );
    },
    async add_filter_to_validation_set() {
      this.loading = true;
      try {
        await this.$api.asset.add_filter_to_validation_set(this.filters);
        await this.load();
      } finally {
        this.loading = false;
      }
    },
    async remove_from_validation_set() {
      await this.runBatchOperation(
        this.resolvedSelectedAssetIds(),
        (ids, onProgress) => this.$api.asset.removeFromValidationSetInBatches(ids, onProgress),
        'myassets.removing_from_validation_set',
      );
    },
    async invalidate_all() {
      this.loading = true;
      try {
        await this.$api.asset.mark_invalidated(this.resolvedSelectedAssetIds());
        await this.load();
      } finally {
        this.loading = false;
      }
    },
    async close_run_model_modal() {
      this.run_model_modal = false;
    },
    async run_model() {
      this.run_model_modal = true;
    },
    async delete_assets() {
      await this.runBatchOperation(
        this.resolvedSelectedAssetIds(),
        (ids, onProgress) => this.$api.asset.deleteInBatches(ids, onProgress),
        'myassets.deleting_assets',
      );
    },
    async add_full_image_bboxes_to_selection(labelName, assetIds) {
      const raw = labelName && typeof labelName === 'object' ? labelName.name : labelName;
      const label = String(raw || '').trim();
      const ids = Array.isArray(assetIds)
        ? [...new Set(assetIds.map((id) => Number(id)).filter((id) => !Number.isNaN(id) && id > 0))]
        : [];
      if (!label) {
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          this.$t('myassets.full_image_bbox_select_label'),
        );
        return;
      }
      if (ids.length === 0) {
        await this.$store.dispatch(
          'snackbars/add_failed_snack',
          this.$t('myassets.full_image_bbox_select_assets'),
        );
        return;
      }
      await this.runBatchOperation(
        ids,
        (batch, onProgress) => this.$api.asset.addFullImageBboxesInBatches(batch, label, onProgress),
        'myassets.adding_full_image_bboxes',
      );
      await this.$store.dispatch(
        'snackbars/add_success_snack',
        this.$t('myassets.full_image_bbox_added', { count: ids.length, label }),
      );
    },
    async delete_assets_in_filter() {
      this.loading = true;
      try {
        await this.$api.asset.delete_assets_in_filter(this.filters);
        await this.load();
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style scoped>

</style>
